import React from 'react';
import { useProductName } from '../hooks/useProductName';

type ProductNameContainerProps = { children: React.ReactNode };

const ProductNameContainer = ({ children }: ProductNameContainerProps) => {
	const { blockClass, componentId } = useProductName();

	return (
		<h1
			data-selection={componentId}
			className={`productNameContainer productNameContainer--${blockClass} vtex-store-components-3-x-productNameContainer mv0 t-heading-4 vtex-store-components-3-x-productNameContainer--${blockClass}`}
		>
			{children}
		</h1>
	);
};

export default ProductNameContainer;
